<script setup>
import { computed } from "vue";
import { isMobile, toLocalDate } from "@/utils/helpers";

const props = defineProps({
  puja: { type: Object, required: true },
  userId: { type: [Number, String], required: true },
});

const itIsMobile = isMobile();

const loteEstado = computed(() => props.puja?.lote?.estado_lote?.slug ?? "");
const ofertaGanadora = computed(() => Number(props.userId) === Number(props.puja?.user_ultima_oferta_id));

const subastaFinalizada = computed(() => {
  const cierre = toLocalDate(props.puja?.fecha_hora_cierre);
  return cierre ? Date.now() >= cierre.getTime() : false;
});

const subastaEnCurso = computed(() => {
  const inicio = toLocalDate(props.puja?.fecha_hora_inicio);
  const cierre = toLocalDate(props.puja?.fecha_hora_cierre);
  if (!inicio || !cierre) return false;
  const now = Date.now();
  return now >= inicio.getTime() && now < cierre.getTime();
});

const lotesPendientes = computed(() => ["subastado", "en-negociacion"].includes(loteEstado.value));

const view = computed(() => {
  let data = null;

  if (subastaFinalizada.value) {
    data = ofertaGanadora.value
      ? { text: "¡GANASTE!", cls: "estado-ganaste", extra: lotesPendientes.value }
      : { text: "PERDISTE", cls: "estado-perdiste", extra: false };
  } else if (subastaEnCurso.value) {
    data = ofertaGanadora.value
      ? { text: "¡VAS GANANDO!", cls: "estado-ganando", extra: false }
      : { text: "TE SUPERARON", cls: "estado-superada", extra: false };
  }

  const alignClass = itIsMobile.value && ofertaGanadora.value ? "align-items-end" : "align-items-center";
  return data ? { ...data, alignClass } : null;
});
</script>

<template>
  <div :class="{ ismobile: itIsMobile }">
    <div v-if="view" class="d-flex flex-column" :class="view.alignClass">
      <span class="badge badge-sm estado-badge" :class="view.cls">
        <i class="fa-solid" :class="view.cls === 'estado-perdiste' ? 'fa-circle-exclamation' : 'fa-circle-check'"></i>
        {{ view.text }}
      </span>

      <small
        v-if="view.extra"
        class="text-justify text-small texto-pendiente text-danger mt-1"
      >
        ¡Tu oferta está pendiente de aprobación!
      </small>
    </div>
  </div>
</template>

<style scoped>
.estado-badge {
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  min-width: 60px !important;
  font-weight: 700;
  line-height: 1.1;
  font-size: 1em !important;
}

.estado-ganaste { background-color: #52e5ba; color: #006c4c; }
.estado-perdiste { background-color: #ff4d4d; color: #640101; }
.estado-ganando  { background-color: rgba(77, 133, 255, 0.31); color: #375dbf; }
.estado-superada { background-color: #ff9304; color: #803f07; }

@media (max-width: 575px) {
  .estado-badge { min-width: 60px !important; max-width: 70px !important; padding: 7px 12px !important; font-size: 0.7em !important; }
}
@media (max-width: 768px) {
  .estado-badge { min-width: 80px !important; max-width: 90px !important; padding: 6px 10px !important; font-size: 0.8em !important; }
}
</style>
